import { Zap, Rocket, Trophy } from 'lucide-react';

export const VISIBILITY_PACKAGES = [
    {
        id: 'boost_1',
        title: 'billing.packages.boost_1.title',
        days: 1,
        weight: 1,
        price: 2.00,
        originalPrice: null,
        badge: null,
        topBadge: null,
        description: 'billing.packages.boost_1.description',
        icon: Zap,
        iconBg: 'bg-blue-50',
        iconColor: 'text-blue-600',
        containerClasses: 'border-gray-200 hover:border-clip-300',
        buttonClasses: 'bg-gray-900 text-white hover:bg-black'
    },
    {
        id: 'boost_7',
        title: 'billing.packages.boost_7.title',
        days: 7,
        weight: 2,
        price: 8.40,
        originalPrice: 14.00,
        badge: 'billing.packages.boost_7.badge',
        topBadge: null,
        description: 'billing.packages.boost_7.description',
        icon: Rocket,
        iconBg: 'bg-purple-50',
        iconColor: 'text-purple-600',
        containerClasses: 'border-gray-200 hover:border-clip-300',
        buttonClasses: 'bg-gray-900 text-white hover:bg-black'
    },
    {
        id: 'boost_15',
        title: 'billing.packages.boost_15.title',
        days: 15,
        weight: 3,
        price: 11.00,
        originalPrice: 30.00,
        badge: 'billing.packages.boost_15.badge',
        topBadge: 'billing.packages.boost_15.top_badge',
        description: 'billing.packages.boost_15.description',
        icon: Trophy,
        iconBg: 'bg-clip-100',
        iconColor: 'text-clip-600',
        containerClasses: 'border-2 border-clip-500 bg-clip-50/10',
        buttonClasses: 'bg-clip-500 text-white hover:bg-clip-600 shadow-lg shadow-clip-200'
    }
];
